import Client from "../client";
import DashboardResource from "../resources/dashboardResource";

class DashboardRepository  {
    private client: Client;
    constructor(client: Client) {
        this.client = client;
    }
    getDeploymentsCountedByWeek(projectIds: string[]) {
        return this.client.get(this.client.getRootDocument().Links["Reporting/DeploymentsCountedByWeek"],
            {projectIds: projectIds.join(",")});
    }
    getDashboard(dashboardFilter?: DashboardFilter): Promise<DashboardResource> {
        return this.client.get<DashboardResource>(this.client.getRootDocument().Links["Dashboard"], dashboardFilter);
    }
}

export interface DashboardFilter {
    projectId?: string;
    releaseId?: string;
    showAll?: boolean;
    highestLatestVersionPerProjectAndEnvironment?: boolean;
}

export default DashboardRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/dashboardRepository.ts